import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

function EmailVerify() {
  const [validUrl, setValidUrl] = useState(false);
  const param = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  console.log("ID:", param.id);
  console.log("Token:", param.token);

  useEffect(() => {
    const verifyEmailUrl = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}auth/${param.id}/verify/${param.token}`
        );

        const data = await response.json();

        if (response.ok) {
          setValidUrl(true);
        } else {
          console.error(data.message);
          setValidUrl(false);
        }
      } catch (err) {
        console.log(err);
        setValidUrl(false);
      }
    };
    verifyEmailUrl();
  }, [param.id, param.token]);

  useEffect(() => {
    setTimeout(() => {
      navigate("/login");
    }, 3000);
  }, []);

  return (
    <>
      {/*       {validUrl ? ( */}
      <div className="d-flex align-items-center justify-content-center h-100 w-100">
        <FontAwesomeIcon
          icon={faCircleCheck}
          size="2xl"
          style={{ color: "#31a008" }}
        />
        <h1>{t("verifCourriel")}</h1>
      </div>
      {/*        ) : (
        <div className="d-flex align-items-center justify-content-center h-100 w-100">
          <FontAwesomeIcon
            icon={faCircleXmark}
            size="2xl"
            style={{ color: "#f00" }}
          />
          <h1>
            Une erreur est survenue lors de la vérification de votre adresse
            courriel
          </h1>
        </div>
      )}  */}
    </>
  );
}

export default EmailVerify;
